import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import styled from "styled-components"

import event_2 from "../../images/events/january/event-2.gif"
import Block from "../elements/Block"
import Gif from "../elements/Gif"
import Month from "../elements/Month"
import Photo from "../elements/Photo"
import Tags from "../elements/Tags"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 . ." ". culture-1 culture-1 ." ". event-3 event-3 event-3" "event-4 event-4 event-4 .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." "event-2 event-2 culture-1 ." "event-2 event-2 event-3 event-3" "event-4 event-4 event-3 event-3" "event-4 event-4 . .";
  }
  @media (min-width: 1200px) {
  }
`

const January = () => {
  const data = useStaticQuery(graphql`
    query {
      janEventOne: file(relativePath: { eq: "events/january/event-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 534, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      janEventThree: file(relativePath: { eq: "events/january/event-3.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      janEventFour: file(relativePath: { eq: "events/january/event-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      janCultureOne: file(
        relativePath: { eq: "events/january/culture-1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 400, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="january">
      <Grid>
        <Block className="event-1">
          <Photo img={data.janEventOne} maxWidth={800} maxHeight={534} />
          <h4 style={{ maxWidth: 800 }}>
            Our year started with a BANG! A bang of love that is. As Duran, one
            of our creative engineers, tied the knot with Bodine ❤️
          </h4>
        </Block>
        <Block className="event-2">
          <Gif src={event_2} maxWidth={400} maxHeight={400} />
          <h4 style={{ maxWidth: 400 }}>
            We migrated everything to Amazon Web Services.
          </h4>
          <Tags
            maxWidth={400}
            words={[
              "awscloud",
              "awslambda",
              "awss3",
              "awscloudformation",
              "ansible",
              "serverless",
              "python",
              "nodejs",
            ]}
          />
        </Block>
        <Block className="event-3">
          <Photo img={data.janEventThree} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            Teamgeek designed a new website for District Works.
          </h4>
        </Block>
        <Block className="event-4">
          <Photo img={data.janEventFour} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            And a co-working dashboard to manage events, workshops and other
            stuff.
          </h4>
        </Block>
        <Block className="culture-1">
          <Photo img={data.janCultureOne} maxWidth={400} maxHeight={400} />
          <h4 style={{ maxWidth: 400 }}>
            And Miss Congeniality 2019 goes to... Gerhard.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default January

/*

work on the event block
distored Yscale to normal yScale when half of viewport is reach
from there onwards we trigger parallax
make event blocks move at different speeds

work on a title reveal

*/
